export const BANNER = {
  text: "Here's all the things you need to get your first course set up with Thinkific and launched on your Shopify store. We're here to help along the way if you need it.",
};
export const REQUIRED_SETUP = {
  title: 'Required Setup',
  text: 'Make sure your checkout option for Shopify store is set to "Customers can only check out using email"',
  button: {
    text: 'Update checkout options',
    url: 'https://www.shopify.com/admin/settings/checkout',
  },
};
export const GETTING_STARTED = {
  title: 'Getting Started',
  texts: [
    'Create a course.',
    'Publish your course.',
    'Add your course to your product pages.',
    'Customize your Site Welcome Email.',
    'Add a link to your Shopify site so your customers can access their courses directly.',
  ],
  button: 'Customize',
  links: [
    'https://support.thinkific.com/hc/en-us/articles/360030735313',
    'https://support.thinkific.com/hc/en-us/articles/360030735313#publish',
    'https://help.shopify.com/en/manual/products/add-update-products',
    'https://support.thinkific.com/hc/en-us/articles/360030369074#sitewelcomeemail',
    'https://support.thinkific.com/hc/en-us/articles/360030369074#linktocourses',
  ],
};
export const RESOURCES = {
  title: 'Resources',
  texts: [
    'Learn everything you need to know about using Shopify with Thinkific.',
    'Learn how to build a quick but effective outline to help build your course.',
    'Learn how to build out the most effective course curriculum.',
  ],
  linksText: 'Read the guide',
  links: [
    'https://support.thinkific.com/hc/en-us/articles/360030735433',
    'https://s3.amazonaws.com/thinkific-import-development/986/OutliningYourCourseCurriculumApr2020Final-200506-110408.pdf',
    'https://s3.amazonaws.com/thinkific-import-development/986/ThinkificOnlineCourseCurriculumandContentGuide-200611-123626.pdf',
  ],
};
export const GET_IN_TOUCH = {
  title: 'Get in touch',
  text: "If you need help, reach out to our support team at support@thinkific.com and we'll be happy to help.",
  button: {
    value: 'mailto:support@thinkific.com',
    text: 'Email us',
  },
};
export const SWITCH_THINKIFIC_ACCOUNT = {
  title: 'Switch to another Thinkific account',
  text: 'Sign out of your current Thinkific account and sign in with a different one to sync its courses with your Shopify store.',
  button: 'Switch accounts',
  modal: {
    title: 'Confirm switching accounts',
    texts: [
      'Courses belonging to this Thinkific account will be removed from your Shopify products list.',
      'Order and enrollment data generated from Shopify will remain on your Thinkific account.',
    ],
    action: 'Disconnect account',
    cancel: 'Cancel',
  },
};
export const LEARN_MORE = 'Learn more';
